"use client";

import { useEffect, useRef, useState } from "react";
import { Product } from "@/app/models/Product";

// import ProductSwiper from "../ProductSwiper";
// import QuantitySelector from "@/app/components/QuantitySelector";
import { useCart } from "@/app/context/CartContext";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import ProductPageWraper from "@/app/components/ProductPageWraper";
import { ProductList } from "@/app/ProductList";

export default function ProductPageClient({ product, products }: { product: Product; products: Product[] }) {
    const prevRef = useRef<HTMLDivElement>(null);
    const nextRef = useRef<HTMLDivElement>(null);

    const [quantity, setQuantity] = useState(1);
    // const [alreadyInCartQty, setAlreadyInCartQty] = useState(0);
    const { cart } = useCart();

    // Compute already in cart quantity reactively
    const alreadyInCartQty =
        cart.find((item) => item.id === product.id)?.quantity || 0;

    useEffect(() => {
        // Reset quantity to 1 if max reached
        if (quantity > product.stock - alreadyInCartQty) {
            setQuantity(Math.max(1, product.stock - alreadyInCartQty));
        }
    }, [alreadyInCartQty, product.stock, quantity]);


    return (


        <div className="container mx-auto relative bg-white rounded-[2rem] p-[0.5rem] sm:rounded-[4rem] sm:p-[2rem]" >

            <div
                ref={prevRef}
                className="absolute top-4 left-4 w-[50px] h-[50px] text-[33px] text-center leading-[39px] z-10 cursor-pointer bg-[#c8c8c8] text-white rounded-full"
            >
                <ChevronLeft style={{ fontSize: '52px' }} />
            </div>
            <div
                ref={nextRef}
                className="absolute top-4 right-4 w-[50px] h-[50px] text-[33px] text-center leading-[39px] z-10 cursor-pointer bg-[#c8c8c8] text-white rounded-full"
            >
                <ChevronRight style={{ fontSize: '52px' }} />
            </div>


            <Swiper
                spaceBetween={30}
                slidesPerView={1}
                loop={true}
                modules={[Navigation]}
                navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                }}
                onInit={(swiper) => {
                    // Important to set navigation elements AFTER swiper is initialized
                    // or refs will be null
                    // @ts-expect-error - Swiper types don't recognize dynamic ref assignment
                    swiper.params.navigation.prevEl = prevRef.current;
                    // @ts-expect-error - Swiper types don't recognize dynamic ref assignment
                    swiper.params.navigation.nextEl = nextRef.current;

                    swiper.navigation.init();
                    swiper.navigation.update();
                }}
                className="w-full"
                style={{ marginBottom: '1rem' }}
                onSlideChange={(swiper) => {
                    // setCurrentProductIndex(swiper.realIndex);
                    const currentProduct = products[swiper.realIndex];
                    window.history.pushState(null, '', `/products/${encodeURIComponent(currentProduct.uniqueName)}`);
                }}

            >
                {products.map((el, index) => (
                    <SwiperSlide key={index} className="h-[400px] flex items-center">
                        <ProductPageWraper el={el} />
                    </SwiperSlide>
                ))}
            </Swiper>



            <div  >
                <ProductList products={products} />
            </div>




        </div>
    );
}
